import { Injectable } from '@angular/core';
import { Subject ,  BehaviorSubject } from 'rxjs';
import { Function } from '../../viewmodels/functions/function';

@Injectable()
export class FunctionEditorService {

  functionTextUpdated = new Subject<string>();

  selectedFunction = new BehaviorSubject<string>(null);

  processFunctionValue = new BehaviorSubject<string>(null);

  processOutputId = new BehaviorSubject<string>(null);

  userFunctions = new BehaviorSubject<Function[]>(null);

  constructor() { }

  public updateFunctionText(text: string) {
    this.functionTextUpdated.next(text.trim());
  }

  public setFunction(functionId: string) {
    this.selectedFunction.next(functionId);
  }

  public setProcessFunctionValue(functionValue: string) {
    this.processFunctionValue.next(functionValue.trim());
  }

  public setProcessOutputId(id: string) {
    this.processOutputId.next(id);
  }

  public setUserFuntions(functions: Function[]) {
    this.userFunctions.next(functions);
  }

}
